// MODEL : Report or Segment
//
// currently we don't have instances of this view used directly,
// but the Top10ReportDashboardItemView and KpiReportDashboardItemView views
// are sub-classing this one
//
define('app/dashboard/widgets/BenchmarkItemView',['require','./ReportDashboardItemView','app/visualizations/FormatFactory','hbs!./BenchmarkItemView.hbs'],function(require) {

	'use strict';

	var ReportDashboardItemView = require('./ReportDashboardItemView'),
		FormatFactory = require('app/visualizations/FormatFactory');

	return ReportDashboardItemView.extend({
		className: 'dashboard-item dashboard-item-benchmark',
		template: require('hbs!./BenchmarkItemView.hbs'),

		initialize: function() {
			// call base class initialize function
			ReportDashboardItemView.prototype.initialize.call(this);

			this.model.set('isLoading', true);
			this.listenTo(this.model, 'dataReceived', this.dataReceived);
			this.listenTo(this.model, 'change', this.render);
		},

		isLoading: function() {
			return this.model.get('isLoading');
		},

		dataReceived: function() {
			this.model.set('isLoading', false);
			this.render();
		},

		deleteEntity: function() {
			var self = this;
			var benchmark = this.model;
			this.dialog.confirm('Are you sure you want to delete ' + this.widgetName.toLowerCase() + ' "' + this.name() + '" ?', 'Delete ' + this.widgetName, function(ok) {

				if (ok) {
					// Logic if 'Yes' is clicked
					benchmark.destroy().then(
						function() {
							self.hide();
						}
					);
				}
			});
		},

		getRawYouValue: function() {
			return this.model.get('results').rows[0][1] ? this.model.get('results').rows[0][1] : 0;
		},

		getRawBenchmarkValue: function() {
			return this.model.get('results').rows[1][1] ? this.model.get('results').rows[1][1] : 0;
		},

		getYouValue: function() {
			var youValue = this.getRawYouValue();
			var benchmarkValue = this.getRawBenchmarkValue();
			var precision = this.getPrecision(youValue) < this.getPrecision(benchmarkValue) ? this.getPrecision(youValue) : this.getPrecision(benchmarkValue);

			return this.getFormattedValue(youValue, precision);
		},

		getBenchmarkValue: function() {
			var youValue = this.getRawYouValue();
			var benchmarkValue = this.getRawBenchmarkValue();
			var precision = this.getPrecision(youValue) < this.getPrecision(benchmarkValue) ? this.getPrecision(youValue) : this.getPrecision(benchmarkValue);

			return this.getFormattedValue(benchmarkValue, precision);
		},

		getFormattedValue: function(val, precision) {
			var formatTime = FormatFactory.formatterForType('TIMESPAN', {});

			switch (this.model.get('benchmark').format) {
				case 'PERCENTAGE':
					return (val * 100).toString().match(/^-?\d+(?:\.\d{0,1})?/)[0];
				case 'TIMESPAN':
					return formatTime(val);
				case 'DECIMAL':
				case 'INTEGER':
					return (val).toFixed(precision);
				case 'CURRENCY':
					return (val).toFixed(2);
				default:
					return val;
			}
		},

		getYouBarHeight: function() {
			var youValue = this.getRawYouValue();
			var benchmarkValue = this.getRawBenchmarkValue();

			// Prevent division by 0
			if (!benchmarkValue || benchmarkValue === 0) {
				return '100';
			}

			return youValue > benchmarkValue ? '100' : (youValue * 100 / benchmarkValue).toFixed(2);
		},

		getBenchmarkBarHeight: function() {
			var youValue = this.getRawYouValue();
			var benchmarkValue = this.getRawBenchmarkValue();

			// Prevent division by 0
			if (!youValue || youValue === 0) {
				return '100';
			}

			return youValue < benchmarkValue ? '100' : (benchmarkValue * 100 / youValue).toFixed(2);
		},

		getPrecision: function(a) {
			var e = 1,
				p = 0;
			if (!isFinite(a)) {
				return 0;
			}

			while (Math.round(a * e) / e !== a) {
				e *= 10;
				p++;
			}

			return p;
		},

		getPercentage: function() {
			var youValue = parseFloat(this.getYouValue());
			var benchmarkValue = parseFloat(this.getBenchmarkValue());

			if (youValue === benchmarkValue) {
				return 0;
			}

			if (benchmarkValue > youValue) {
				return (Math.round((100 - ((youValue / benchmarkValue) * 100)) * 100) / 100).toFixed(1);
			} else {
				if (benchmarkValue === 0) {
					return 100;
				}
				return (Math.round((((youValue / benchmarkValue) * 100) - 100) * 100) / 100).toFixed(1);
			}
		},

		isEqual: function() {
			var youValue = parseFloat(this.getYouBarHeight());
			var benchmarkValue = parseFloat(this.getBenchmarkBarHeight());

			return youValue === benchmarkValue;
		},

		isPositive: function() {
			var youValue = parseFloat(this.getYouBarHeight());
			var benchmarkValue = parseFloat(this.getBenchmarkBarHeight());

			return youValue > benchmarkValue;
		},

		isNegative: function() {
			var youValue = parseFloat(this.getYouBarHeight());
			var benchmarkValue = parseFloat(this.getBenchmarkBarHeight());

			return youValue < benchmarkValue;
		},

		isPercentage: function() {
			return this.model.get('benchmark').format === 'PERCENTAGE';
		},

		isCurrency: function() {
			return this.model.get('benchmark').format === 'CURRENCY';
		},

		isInverted: function() {
			return this.model.get('benchmark').target === 'LOW';
		}
	});
});

